import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAccountAnalytic } from "app/services/dashboard/accountAnalyticService";
import { fetchDeviceTypes } from "app/services/dashboard/deviceType.service";

import { BASE_URL } from "static/constants";

export const accountAnalyticApi = createApi({
  reducerPath: "accountAnalyticApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  endpoints: ({ query }) => ({
    getAccountAnalytic: query({
      queryFn: ({ yearlyFilter, accountFilter, deviceFilter }) => {
        return {
          data: getAccountAnalytic({
            yearlyFilter,
            accountFilter,
            deviceFilter,
          }),
        };
      },
    }),
    getDeviceTypes: query({
      queryFn: ({ includeHF }) => {
        return {
          data: fetchDeviceTypes(includeHF),
        };
      },
    }),
  }),
});

export const { useGetAccountAnalyticQuery, useGetDeviceTypesQuery } =
  accountAnalyticApi;
